<template>
  <NotificationsNamiCreatorCommentToChapter
    v-if="
      notification.notification.notificationType ===
      NamiNotificationType.CreatorCommentToChapter
    "
    :is-unread
    :notification="notification.notification"
  />
  <NotificationsNamiCreatorCommentToNovelChapter
    v-else-if="
      notification.notification.notificationType ===
      NamiNotificationType.CreatorCommentToNovelChapter
    "
    :is-unread
    :notification="notification.notification"
  />
  <NotificationsNamiCreatorCommentToTitle
    v-else-if="
      notification.notification.notificationType ===
      NamiNotificationType.CreatorCommentToTitle
    "
    :is-unread
    :notification="notification.notification"
  />
  <NotificationsNamiCreatorReactionToChapter
    v-else-if="
      notification.notification.notificationType ===
      NamiNotificationType.CreatorReactionToChapter
    "
    :is-unread
    :notification="notification.notification"
  />
  <NotificationsNamiCreatorReactionToNovelChapter
    v-else-if="
      notification.notification.notificationType ===
      NamiNotificationType.CreatorReactionToNovelChapter
    "
    :is-unread
    :notification="notification.notification"
  />
  <NotificationsNamiCreatorTitleFollow
    v-else-if="
      notification.notification.notificationType ===
      NamiNotificationType.CreatorTitleFollow
    "
    :is-unread
    :notification="notification.notification"
  />
  <NotificationsNamiOfficialAnnouncement
    v-else-if="
      notification.notification.notificationType ===
      NamiNotificationType.OfficialAnnouncement
    "
    :is-unread
    :notification="notification.notification"
  />
  <NotificationsNamiPaymentOrganizationSubscription
    v-else-if="
      notification.notification.notificationType ===
      NamiNotificationType.PaymentOrganizationSubscription
    "
    :is-unread
    :notification="notification.notification"
  />
  <NotificationsNamiReaderChapterPublishedToFollowedTitle
    v-else-if="
      notification.notification.notificationType ===
      NamiNotificationType.ReaderChapterPublishedToFollowedTitle
    "
    :is-unread
    :notification="notification.notification"
  />
  <NotificationsNamiReaderNovelChapterPublishedToFollowedTitle
    v-else-if="
      notification.notification.notificationType ===
      NamiNotificationType.ReaderNovelChapterPublishedToFollowedTitle
    "
    :is-unread
    :notification="notification.notification"
  />
  <NotificationsNamiSocialNewFollow
    v-else-if="
      notification.notification.notificationType ===
      NamiNotificationType.SocialNewFollow
    "
    :is-unread
    :notification="notification.notification"
  />
  <NotificationsNamiSocialReactionToComment
    v-else-if="
      notification.notification.notificationType ===
      NamiNotificationType.SocialReactionToComment
    "
    :is-unread
    :notification="notification.notification"
  />
  <NotificationsNamiSocialReactionToPost
    v-else-if="
      notification.notification.notificationType ===
      NamiNotificationType.SocialReactionToPost
    "
    :is-unread
    :notification="notification.notification"
  />
  <NotificationsNamiSocialReplyToComment
    v-else-if="
      notification.notification.notificationType ===
      NamiNotificationType.SocialReplyToComment
    "
    :is-unread
    :notification="notification.notification"
  />
  <NotificationsNamiSocialReplyToPost
    v-else-if="
      notification.notification.notificationType ===
      NamiNotificationType.SocialReplyToPost
    "
    :is-unread
    :notification="notification.notification"
  />
  <NotificationsNamiSocialRepostOfPost
    v-else-if="
      notification.notification.notificationType ===
      NamiNotificationType.SocialRepostOfPost
    "
    :is-unread
    :notification="notification.notification"
  />
  <NotificationsNamiAchievementUnlocked
    v-else-if="
      notification.notification.notificationType ===
      NamiNotificationType.AchievementUnlocked
    "
    :is-unread
    :notification="notification.notification"
  />
  <!-- <NotificationsNamiTestNotification
    v-else-if="notification.notification.notificationType === NamiNotificationType.TestNotification"
    :is-unread
    :notification="notification.notification"
  /> -->
</template>

<script setup lang="ts">
import {
  NamiNotificationType,
  type NamiNotification,
} from "~/src/notifications/types/nami";
import type { Props } from "../NotificationsItem.vue";
import NotificationsNamiAchievmentUnlocked from "./NotificationsNamiAchievementUnlocked.vue";

defineProps<
  {
    notification: NamiNotification;
  } & Pick<Props, "isUnread">
>();
</script>
